import React from 'react';
import { Link } from 'react-router-dom';
import { Hash, X } from 'lucide-react';

interface HashtagChipProps {
  hashtag: string;
  count?: number;
  variant?: 'default' | 'purple' | 'blue' | 'removable';
  onRemove?: () => void;
  className?: string;
}

export const HashtagChip: React.FC<HashtagChipProps> = ({
  hashtag,
  count,
  variant = 'default',
  onRemove,
  className = ''
}) => {
  const cleanHashtag = hashtag.replace('#', '');

  const getVariantStyles = () => {
    switch (variant) {
      case 'purple':
        return 'bg-purple-100 text-purple-800 hover:bg-purple-200';
      case 'blue':
        return 'bg-blue-100 text-blue-800 hover:bg-blue-200';
      case 'removable':
        return 'bg-gray-100 text-gray-800 hover:bg-gray-200';
      default:
        return 'bg-gray-100 text-gray-700 hover:bg-gray-200';
    }
  };

  const content = (
    <div className={`inline-flex items-center px-3 py-1 rounded-full text-sm transition-colors ${getVariantStyles()} ${className}`}>
      <Hash className="h-3 w-3 mr-1" />
      <span>{cleanHashtag}</span>
      {count !== undefined && (
        <span className="ml-1 text-xs opacity-75">({count})</span>
      )}
      {variant === 'removable' && onRemove && (
        <button
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            onRemove();
          }}
          className="ml-2 text-gray-500 hover:text-gray-700 transition-colors"
        >
          <X className="h-3 w-3" />
        </button>
      )}
    </div>
  );

  if (variant === 'removable') {
    return content;
  }

  return (
    <Link to={`/hashtag/${cleanHashtag}`}>
      {content}
    </Link>
  );
};